import { AbstractGitEntityStore } from '@y42/feature/git/state';
import { DatasourceTableGitFactoryService } from './datasource-table-git-factory.service';
import { DatasourceTableState } from './datasource-table.model';

const initialState: DatasourceTableState = {
  ui: {},
  active: null,
};

export abstract class DatasourceTableStore extends AbstractGitEntityStore<DatasourceTableState> {
  constructor(protected readonly name: string, protected readonly gitFactory: DatasourceTableGitFactoryService) {
    super({ name, gitFactory, initialState });
  }
}
